import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";

export default function Footer() {
  return (
    <footer className="mt-16 bg-background-100 border-t border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        {/* brand */}
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2">
            <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-xl">
              <i className="ri-water-flash-line"></i>
            </span>
            <span className="font-heading text-2xl text-primary-600">吃瓜视频网</span>
          </div>
          <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
            收录全网娱乐八卦、圈内速递、明星动态、综艺片段、影视花絮与红人视频，每日更新娱乐圈新鲜事，带你一分钟掌握圈内动态。
          </p>
          <div className="mt-4 flex items-center gap-2 text-foreground-500 text-sm">
            <span className="flex items-center gap-1"><i className="ri-mail-line"></i>contact@chigua-video.example.com</span>
          </div>
        </div>

        {/* quick nav */}
        <nav aria-label="快速导航">
          <h4 className="text-sm font-bold text-foreground-950 mb-4">快速导航</h4>
          <ul className="space-y-2.5 text-sm text-foreground-600">
            <li><Link to="/" className="hover:text-primary-600">首页</Link></li>
            <li><Link to="/about" className="hover:text-primary-600">关于我们</Link></li>
            <li><Link to="/search?q=热点" className="hover:text-primary-600">热点专题</Link></li>
            <li><Link to="/about#contact" className="hover:text-primary-600">投稿爆料</Link></li>
          </ul>
        </nav>

        {/* categories */}
        <nav aria-label="栏目导航">
          <h4 className="text-sm font-bold text-foreground-950 mb-4">内容栏目</h4>
          <ul className="space-y-2.5 text-sm text-foreground-600">
            {categories.map((c) => (
              <li key={c.slug}>
                <Link to={`/category/${c.slug}`} className="hover:text-primary-600">
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        {/* disclaimer */}
        <div className="col-span-2 md:col-span-1">
          <h4 className="text-sm font-bold text-foreground-950 mb-4">内容声明</h4>
          <p className="text-sm text-foreground-600 leading-relaxed">
            本站内容均来源于公开渠道整理与用户投稿，仅供娱乐参考。如涉侵权或信息有误，请通过联系我们页面反馈，我们将及时处理并尊重原创。
          </p>
          <div className="mt-4 flex items-center gap-3 text-xl text-foreground-500">
            <a href="#" aria-label="微信" className="hover:text-primary-600"><i className="ri-wechat-line"></i></a>
            <a href="#" aria-label="微博" className="hover:text-primary-600"><i className="ri-weibo-line"></i></a>
            <a href="#" aria-label="哔哩哔哩" className="hover:text-primary-600"><i className="ri-bilibili-line"></i></a>
            <a href="#" aria-label="抖音" className="hover:text-primary-600"><i className="ri-music-2-line"></i></a>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-foreground-500">
          <p>© 2026 吃瓜视频网 版权所有 · 娱乐八卦与圈内速递平台</p>
          <p className="flex items-center gap-1"><i className="ri-heart-line text-primary-500"></i>理性吃瓜，快乐追剧</p>
        </div>
      </div>
    </footer>
  );
}